import { createContext, useCallback, useEffect, useRef, useState } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Api
import { Col, Row } from "react-bootstrap";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import DrillDownOffCanvas from "../../../../app/common-components/DrillDown/DrillDownOffCanvas.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData.jsx";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice.js";
import { effciencyApi } from "../../../../app/services/efficiencyApi.js";
import { convertEpochToDate, useCommonAlert } from "../../../../app/utilities/helpers.js";
import { updateSelectedApp } from "../../../../Modules/configuration/HomeSlice.js";
import { userAccountList } from "../cmdb-overview/appConfigSlice";
import { ReviewDays } from "../cmdb-overview/Constants.js";

// 3rd Party Libraries
import _, { get } from "lodash";
import { FiTrash2 } from "react-icons/fi";

// Styles
import "../styles.scss";


export const ProjectContext = createContext();
const Users = (props) => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const { userName } = useSelector((state) => state.common.loggedUser);
  const [uid, setUid] = useState("");
  const [displayName, setdisplayName] = useState("");
  const [mail, setmail] = useState("");
  const [getId, setGetId] = useState("");
  const [users, setUsers] = useState([]);
  const [removedUsers, setRemovedUsers] = useState([]);
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");

  const { UserLoadPage } = useSelector((state) => state.configuration);
  const [Userstate, setUserstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    UserList: {},
  });
  const { efficiency } = useSelector((state) => state);
  const datePickerRef = useRef(null);
  const TableData = get(efficiency, "appConfig.userTableData", []);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedUser, setselectedUser] = useState("");
  const [userDeleteLoad, setUserDeleteLoad] = useState(false);
  const [state, setState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    totalPages: 1,
    tableData: [],
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    deleteModalOpen: false,
    loadPage: false,
    modalOpen: false,
    deleteUser: "",
    deleteIds: "",
    modalOpenUserEdit: false,
    userList: [],
    userDetails: [],
    userPage: [],
    userAdd: [],
    userCount: [],
    userTableData: [],
    reviewaccess: [],
    revieweruser: [],
    userDate: [],
    Usercode: [],
    selectedReviewers: [],
    uid: "",
    displayName: "",
    mail: "",
    selectDays: [],
    reviewerDate: [],
    alertMailRequest: [],
    loading: false,
    UserError: false,
    UserErrorMessage: "",
    addBodyUser: false,
    conformationPop: false,
  });

  const userListData = state.userTableData;

  const location = useLocation();
  const { state: locationState } = useLocation();
  const isNavigated = _.get(location, "state.isNavigated", false);
  const payloadid = locationState?.id;
  const applicationName = locationState?.appName;
  useEffect(() => {
    if (locationState && locationState.applabel) {
      const homeNavApp = {
        label: `${locationState.applabel}[${locationState.appCode}]`,
        value: locationState.appCode,
        id: locationState.id,
      };
      dispatch(updateSelectedApp(homeNavApp));
    } else {
      dispatch(updateSelectedApp({}));
    }
  }, [dispatch]);
  const {
    userAccountListData,
    userAccountListLoading,
  } = useSelector((state) => state.appConfig);
  const calculatedPageCount = userAccountListData?.totalCount
    ? Math.ceil(userAccountListData?.totalCount / pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

  const navigate = useNavigate();
  const [getUserListUpdate] = effciencyApi.useGetUserListUpdateMutation();
  const [getUserListDate] = effciencyApi.useGetUserListDateMutation();
  const [getUserDueDate] = effciencyApi.useGetUserDueDateMutation();
  const [getUserListReview] = effciencyApi.useGetUserListReviewMutation();
  const [getUserAdd] = effciencyApi.useGetUserAddMutation();
  const [getUserConfig] = effciencyApi.useGetUserConfigMutation();
  const [getUserdelete] = effciencyApi.useGetUserdeleteMutation();
  const [getUserAppcode] = effciencyApi.useGetUserAppcodeMutation();
  const [getReviewAccess] = effciencyApi.useGetReviewAccessMutation();
  const [getUserAccessReviewAlert] =
    effciencyApi.useGetUserAccessReviewAlertMutation();
  const [getDeleteUserReviewer] =
    effciencyApi.useGetDeleteUserReviewerMutation();
  const [getUserAccessDueDate] = effciencyApi.useGetUserAccessDueDateMutation();
  const [selectedReviewer, setSelectedReviewer] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [limitDate, setLimitDate] = useState(null);
  const [currentAction, setCurrentAction] = useState("");
  const [dateValue, setDateValue] = useState(new Date());
  const [search, setSearch] = useState([]);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [reviewFrequencyDays, setreviewFrequencyDays] = useState([]);
  const [reviewDueIn, setreviewDuein] = useState([]);
  const [reviewAlertMail, setreviewAlertMail] = useState([]);

  let userData = "";

  userData = userListData.data?.map((user) => ({
    uID: user.uid,
    displayName: user.displayName,
    mail: user.mail,
    accountCreatedDate: user.accountCreatedDate,
    id: user.payloadid,
  }));

  const clickbtn = () => {
    clearValidation();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
    return openuser("add", 0);
  };

  // const onChange = (e) => {
  //   setState({
  //     ...state,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  const columns = [
    {
      Header: "Username",
      accessor: "uid",
    },
    {
      Header: "Full Name",
      accessor: "displayName",
    },
    {
      Header: "Email ID",
      accessor: "mail",
    },
    {
      Header: "Added Date",
      accessor: "accountCreatedDate",
      Cell: ({ value }) => {
        return <>{value ? convertEpochToDate(value) : "-"}</>;
      },
    },
    {
      Header: "Action",
      accessor: "Action",
      tdClassName: "text-center",
      className: "text-center",
      thClassName: "text-center",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          {" "}
          <div className="actcol p-0 usersPaddingActol">
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              onClick={() => {
                setState((state) => ({
                  ...state,
                  modalOpen: true,
                  deleteUser: row.original.id,
                  deleteIds: row.original.uID,
                }));
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  const payload = {
    keyword: searchKey,
  };
  useEffect(() => {
    if (userName !== "" || uid !== "") {
      getUserAdd(payloadid)
        .unwrap()
        .then((userListResp) => {
          setState((state) => ({
            ...state,
            userAdd: userListResp.map((user) => ({ label: user, value: user })),
          }));
        });
    }
  }, [userName, uid]);

  useEffect(() => {
    if (userName !== "" || uid !== "") {
      getUserConfig(payloadid)
        .unwrap()
        .then((userListResp) => {
          setState((state) => ({
            ...state,
            userDetails: userListResp.map((user) => ({
              label: user.userName,
              value: user.userName,
              displayName: user.displayName,
              mail: user.mail,
            })),
          }));
        });
    }
  }, [userName, uid]);
  useEffect(() => {
    getUserAppcode(payloadid)
      .unwrap()
      .then((data) => {
        setState((state) => ({
          ...state,
          Usercode: data,
        }));
      });
  }, []);
  const reviewData = state.reviewaccess.data;

  const getuserAccountInfo = () => {
    dispatch(
      userAccountList({
        cmdb: payloadid,
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload,
      })
    );
  };

  useEffect(() => {
    getuserAccountInfo();
  }, [pageNo, pageLimit, searchKey]);
  const isEmpty = selectedUser === "";

  const handleRemoveUsers = (itemToRemove) => {
    let userreviwer = [itemToRemove];
    setState((prevState) => ({
      ...prevState,
      revieweruser: prevState.revieweruser.filter(
        (item) => item !== itemToRemove
      ),
    }));
    handleDeleteUser(userreviwer, payloadid);
  };
  const deleteUser = () => {
    getUserdelete({ payloadid, userName: userName, uID: state.deleteIds })
      .unwrap(setUserDeleteLoad(true))
      .then((data) => {
        setUserDeleteLoad(false);
        if (data?.statusCodeValue === 200) {
          getuserAccountInfo();
          // callCommonAlert("success",_.get(data, "data.body")
          // ? data.data.body
          // : "User Configuration deleted successfully")
          callCommonAlert("success", data.body);
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          hideCommonAlert();
        } else if (data?.statusCodeValue === 400) {
          getuserAccountInfo();
          callCommonAlert(
            "success",
            _.get(data, "data.body")
              ? data.data.body
              : "Something went wrong please try again"
          );
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          hideCommonAlert();
        }
      })
      .catch((error) => {
        callCommonAlert("error", error.message);
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
      });
  };
  const validateForm = () => {
    let formValidation = true;
    if (users === "") {
      setState((prevState) => ({
        ...prevState,
        UserError: true,
        UserErrorMessage: "Username should not be empty",
      }));
      formValidation = false;
    }
    return formValidation;
  };

  const clearValidation = () => {
    setState((state) => ({
      ...state,
      UserError: false,
      UserErrorMessage: "",
    }));
  };

  const handleOnChange = (name, selected) => {
    const selectedUserObject = state.userDetails.find(
      (user) => user.value === selected.value
    );

    if (name === "User Details") {
      setState({
        ...state,
        uid: selected.value,
        displayName: selectedUserObject.displayName,
        mail: selectedUserObject.mail,
        UserError: false,
        UserErrorMessage: "",
        conformationPop: true,
      });
    }

    setUsers(selected.value);
    setmail(selectedUserObject.mail);
    setdisplayName(selectedUserObject.displayName);
  };

  const handleSearch = (searchString, IterationList) => {
    const matchedUsers = IterationList.filter((item) =>
      item.label.toLowerCase().includes(searchString.toLowerCase())
    );
    setSearch(matchedUsers);
  };

  const handleSaveAdd = () => {
    const validation = validateForm();
    if (validation) {
      const payload = {
        createBy: "",
        createdDt: "",
        displayName: displayName,
        id: 0,
        mail: mail,
        updateBy: "",
        updateDt: "",
        userName: users,
      };
      try {
        getUserListUpdate({ payload, payloadid, userName }).then((data) => {
          if (data.data.statusCodeValue === 200) {
            getuserAccountInfo();
            adduserclose();
            callCommonAlert(
              "success",
              _.get(data, "data.body")
                ? data.data.body
                : "User Details saved Succesfully"
            );
            setState((state) => ({
              ...state,
              modalOpen: false,
            }));
            hideCommonAlert();
          } else if (data.data.statusCodeValue === 400) {
            callCommonAlert(
              "error",
              _.get(data, "data.body")
                ? data.data.body
                : "Something went wrong please try again"
            );
            setState((state) => ({
              ...state,
              modalOpen: false,
            }));
            hideCommonAlert();
          }
        });
      } catch (error) {
        callCommonAlert("error", "Something went wrong. Please try again");
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
        hideCommonAlert();
      }
    }
  };
  const submitSave = useCallback(async () => {
    if (currentAction === "edit") {
      handleSaveEdit();
    } else {
      handleSaveAdd();
    }
  });
  const addmodalCancelUser = () => {
    setState((state) => ({
      ...state,
      addBodyUser: true,
    }));
  };
  const closeModalCancelUser = () => {
    setState((state) => ({
      ...state,
      addBodyUser: false,
    }));
  };
  const addBodyCloseUser = () => {
    setState({
      ...state,
      addBodyUser: false,
    });
  };
  const addBodyCancelUser = () => {
    return (
      <>
        <DiscardChanges
          title={"add"}
          discardClick={adduserclose}
          cancelClick={closeModalCancelUser}
        />
      </>
    );
  };
  const handleDeleteUser = async (userreviwer, payloadid) => {
    const payload = {
      cmdbId: payloadid,
      usernames: userreviwer,
    };
    getDeleteUserReviewer(payload);
  };
  const adduserclose = async () => {
    dispatch(hideOffCanvas(false));
    setIsSidebarOpen(false);
    clearValidation();
    resetInput();
    addBodyCloseUser();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };

  const resetInput = () => {
    setdisplayName("");
    setmail("");
    setUsers("");
  };
  const openuser = async (action, id) => {
    resetInput();
    clearValidation();
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
  };
  const onDeleteData = (data) => {
    setState((state) => ({
      ...state,
      projectId: data.id,
      deleteModalOpen: false,
    }));
  };
  const modalBody = () => (
    <>
      {userDeleteLoad ? (
        <Spinners />
      ) : (
        <div>
          <h4 className="delete-h"> Delete User Configuration</h4>
          <p>Are you sure you want to unmap the user from this application?</p>
          <div className="btnswrap btn-dlt">
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={handleClose}
            />
            <ButtonComponent
              text="Delete"
              className={"btnStyle btn btn-primary"}
              onClick={deleteUser}
            />
          </div>
        </div>
      )}
    </>
  );
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
    hideCommonAlert();
  };

  const handleShowManage = () => {
    setState({
      ...state,
      modalOpenUserEdit: true,
    });
    if (dateValue === null || dateValue != new Date()) {
      setDateValue(new Date());
    }
    getUserDueDate(payloadid)
      .unwrap()
      .then((data) => {
        setreviewAlertMail(data.alertDaysForMail);
        setreviewFrequencyDays(data.inputDays);
        setreviewDuein(data.daysLeft);
        setSelectedDays(
          ReviewDays.find((option) => option.value === data.type)
        );

        const { pro } = setState((state) => ({
          ...state,
          reviewerDate: data,
        }));
      });
  };
  const handleSelectedDays = (selectDays) => {
    setSelectedDays(selectDays);
  };

  const handleUserEditClose = () => {
    setState({
      ...state,
      modalOpenUserEdit: false,
      selectedReviewers: [],
    });
  };

  const btnData = [
    {
      text: "Map New",
      function: clickbtn,
      className: "solid-btn",
    },
  ];
  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }
  return (
    <>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.addBodyUser}
          modalBody={addBodyCancelUser}
          modalHide={addmodalCancelUser}
          closeBtn={true}
          closeBtnFuc={addBodyCloseUser}
        />
        <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter your Project data."}
        />
      </ProjectContext.Provider>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12  col-sm-12"></div>
      </div>
      <div className="mt-3 p-0-5">
        <div className="row">
          <div>
            <div className="grid-table">
              <CompleteTableData
                isLoading={userAccountListLoading}
                data={userAccountListData?.data || []}
                columns={columns}
                onPageLimitChange={getLimit}
                onPageNoChange={getPage}
                onSearch={getSearchKey}
                curentPageNumber={pageNo}
                pageLimit={pageLimit}
                searchKey={searchKey}
                totalPageCount={finalPageCount}
                listCount={userAccountListData?.totalCount}
                btnData={btnData}
                moveSearchToEnd={true}
              />
            </div>
          </div>
          <CustomOffCanvas className="custom-off-canvas">
            <h3
              className="flowhead"
              id="updatehead"
              style={{ display: "block" }}
            >
              {currentAction === "edit" ? "Update User" : "Map New User"}{" "}
            </h3>
            <Row className="m-0">
              <Col>
                <label className="form-label">Username<span className="RedHighlight">*</span></label>
                <CustomSelectDropDown
                  label={"Username*"}
                  name={"username"}
                  id="uid"
                  options={state.userDetails}
                  value={users}
                  customClassName="notFocus"
                  onSearch={(searchString) =>
                    handleSearch(searchString, state.userDetails)
                  }
                  containerClassName={"frmgroup validate default-input"}
                  selected={state.userDetails}
                  onChange={(selected) =>
                    handleOnChange("User Details", selected)
                  }
                  placeholder={"Enter Username"}
                  error={state["UserError"]}
                  errorMessage={state["UserErrorMessage"]}
                />
              </Col>
              <Col>
                <div className="frmgroup default-input">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    id="usegroup"
                    value={displayName}
                    name={"fullName"}
                    placeholder={"Full Name"}
                    autoComplete={"off"}
                    disabled={true}
                    label={"Full Name"}
                    className="form-control"
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-0">
              <Col>
                <div className="frmgroup default-input">
                  <label className="form-label">Email ID</label>
                  <input
                    className="form-control"
                    type="text"
                    id="user2"
                    value={mail}
                    name={"email"}
                    placeholder={"Email ID"}
                    autoComplete={"off"}
                    disabled={true}
                    label={"Mail"}
                  />
                </div>
              </Col>
              <Col></Col>
            </Row>
            <input
              type="hidden"
              name={"id"}
              id="id"
              className="form-control"
              placeholder="id"
              value={getId}
              onChange={(e) => setGetId(e.target.value)}
              maxLength="50"
            />
            <Row className="m-0">
              <Col></Col>
              <Col>
                <div
                  className="server-btn"
                  style={{ display: "block", justifyContent: "end" }}
                >
                  <ButtonComponent
                    text="Cancel"
                    className="cancelBtnStyle"
                    onClick={() => {
                      if (state.conformationPop) {
                        addmodalCancelUser();
                      } else {
                        adduserclose();
                      }
                    }}
                  />
                  <ButtonComponent
                    className="btnStyle"
                    onClick={submitSave}
                    text="Save"
                  />
                </div>
              </Col>
            </Row>
          </CustomOffCanvas>
        </div>
      </div>
    </>
  );
};

export default Users;
